<section id="charts" class="services-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Le nostre <span>classifiche</span></h2>
            <p>Ogni settimana e ogni mese pubblichiamo le classifiche dei post dei principali social, considerando sempre 48 ore di tempo necessarie a raggiungere il picco di maggior successo.</p>
        </div>
        <div class="row justify-content-center">
            <div class="col-6">
                <div class="single-box" (click)="goToInstagramChart()">
                    <div class="icon">
                        <i class="fab fa-instagram"></i>
                    </div>
                    <h3>Instagram</h3>
                    <p>Scopri le classifiche dei post di Instagram.</p>
                </div>
            </div>
            <div class="col-6">
                <div class="single-box" (click)="goToTikTokChart()">
                    <div class="icon">
                        <i class="fab fa-tiktok"></i>
                    </div>
                    <h3>TikTok</h3>
                    <p>Scopri i video più popolari di TikTok.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="shape2"><img alt="image" src="assets/img/shape1.png"></div>
</section>
